<template>
  <div class="creation-date-selection">
    <template v-if="!date">
      <!-- if date not set, display buttons -->
      <ExtraBtnSquare icon="fad fa-stopwatch" :label="$t(labelAsap)" @click="$emit('selectAsap')" />
      <ExtraBtnSquare icon="fad fa-calendar-range" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_SELECTION')" @click="selectDate" />
    </template>
    <template v-if="date && showDateSelected">
      <!-- if date is already set, display it -->
      <a @click="$emit('selectDate')">
        <IconBoxWrapper icon="icon-f-calendar">
          <QInput
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_SELECTED')"
            :model-value="dateFormatted"
            class="creation-date-selected"
            borderless
            readonly
          />
        </IconBoxWrapper>
      </a>
    </template>
  </div>
</template>

<script>
  import { DatesHelpers } from "@core/helpers";

  export default {
    props: {
      date: {
        type: Date,
        default: null,
      },
      labelAsap: {
        type: String,
        default: "ETAB.PAGES.DEMANDS.CREATION.@DATE_ASAP",
      },
    },
    emits: ["selectAsap", "selectDate", "setDate"],
    data() {
      return {
        showDateSelected: false,
      };
    },
    computed: {
      dateInternal: {
        get() {
          return this.date;
        },
        set(value) {
          this.$emit("setDate", value);
        },
      },
      dateFormatted() {
        return DatesHelpers.getDayjs(this.date).format("L");
      },
    },
    mounted() {
      this.setShowDateSelected();
    },
    methods: {
      selectDate() {
        this.$emit("selectDate");
        this.showDateSelected = true;
      },
      setShowDateSelected() {
        if (this.date) {
          this.showDateSelected = true;
        }
      },
    },
  };
</script>

<style lang="scss">
  .creation-date-selection {
    display: flex;
    align-items: center;
    justify-content: center;

    > button {
      margin: 5px;
    }

    .creation-date-selected {
      padding: 0px 15px;
    }
  }
</style>
